import {qs, qsa} from '../util/querySelector';
import Velocity from 'velocity-animate';
import screenfull from 'screenfull';
import {isAndroid, isIOS} from '../util/browser';

const headerEl = qs`.kg-header`;
const headerElContainer = headerEl.querySelector('.kg-header__wrapper');
const titleWrapperEl = qs`[data-home-hero] [data-title-wrapper]`;
const slideImageContainerEls = qsa`.slide__image-container`;
const videoDismissTrigger = qs`[data-home-hero] [data-video-dismiss-trigger]`;
const videoPlayerWrapperEl = qs`[data-home-hero] [data-video-player-wrapper]`;
const videoPlayerEl = qs`[data-home-hero] [data-video-player]`;
const bgVideoPlayerEl = qs`[data-home-hero] [data-bg-video-player]`;
const videoIsolationCoverEl = qs`[data-home-hero] [data-video-isolation-cover]`;
const videoPlayerOverlayEl = qs`[data-home-hero] [data-video-overlay]`;
const videoPlayerShowboxEl = qs`[data-home-hero] [data-video-showbox]`;

function initHeroVideo() {
  let maxScrollDistancePercentage = 0.25;

  qs`[data-home-hero] [data-video-trigger]`.addEventListener('click', startVideoPlayer);
  window.addEventListener('scroll', () => {
    if (isIOS || isAndroid || videoPlayerEl.classList.contains('hidden') || window.scrollY < (maxScrollDistancePercentage * window.innerHeight)) {
      return;
    }

    stopVideoPlayer();
  });
  videoPlayerEl.addEventListener('ended', stopVideoPlayer);
  videoDismissTrigger.addEventListener('click', stopVideoPlayer);
  window.addEventListener('keydown', e => {
    if (!videoPlayerEl.classList.contains('hidden') && e.key === 'Escape') {
      stopVideoPlayer();
    }
  });
  if (screenfull.isEnabled) {
    // stop the on-demand video as soon as fullscreen is dismissed to prevent inline video play
    screenfull.on('change', () => {
      if (!screenfull.isFullscreen && !videoPlayerEl.classList.contains('hidden')) {
        stopVideoPlayer();
      }
    });
  }
  document.addEventListener('click', e => {
    if (!videoPlayerEl.classList.contains('hidden') && !e.target.closest('[data-home-hero] [data-video-player]')) {
      // prevent from clicking links below it
      e.preventDefault();
      e.stopPropagation();
      stopVideoPlayer();
    }
  });
}

function forceShowGlobalHeader() {
  Velocity.animate(headerElContainer, {
    translateY: '0px',
    duration: '50',
    begin: function () {
      headerElContainer.classList.remove('kg-header--hidden');
    },
  }).then(function () {
    headerElContainer.classList.add('kg-header--revealed');
  });
}

function startVideoPlayer(e) {
  // prevent clicking open button from collapsing it afterwards as event propogates up to global handler
  if (e) {
    e.stopPropagation();
  }

  videoPlayerEl.volume = 0.5;
  videoPlayerEl.currentTime = 0;

  if (isIOS) {
    videoPlayerEl.play();
    return;
  }

  if (isAndroid && screenfull.isEnabled) {
    videoPlayerEl.classList.remove('hidden');
    videoPlayerShowboxEl.classList.remove('hidden');
    videoPlayerEl.play();
    screenfull.request(videoPlayerEl);
    return;
  }

  // must trigger play in clickhandler for safari + ipados
  videoPlayerEl.play();

  return Velocity.animate(titleWrapperEl, {
    opacity: 0,
    duration: 1000,
    begin: function() {
      // shrink the content below the hero
      slideImageContainerEls.forEach(el => el.classList.add('slide__image-container--shrunk'));
      videoPlayerOverlayEl.classList.add('is-disabled');
    },
    complete: function() {
      setTimeout(() => {
        // show and lock the global header
        forceShowGlobalHeader();
        headerEl.setAttribute('data-lock', true);
        headerEl.classList.add('kg-header--fill-alt');
        headerEl.classList.remove('kg-header--top');
        // show the on-demand video and hide bg video
        bgVideoPlayerEl.classList.add('hidden');
        videoPlayerOverlayEl.classList.add('hidden');
        videoPlayerEl.classList.remove('hidden');
        videoPlayerShowboxEl.classList.remove('hidden');
        // show the isolation cover
        videoIsolationCoverEl.classList.add('is-visible');
        videoPlayerWrapperEl.classList.add('home-hero__video-wrapper--above-isolation-cover');
        // show the dismiss trigger
        videoDismissTrigger.classList.remove('hidden');
      }, 1000);
    }
  });
}


let isStopping = false;

function stopVideoPlayer() {
  if (isStopping) {
    return;
  }

  if (isAndroid) {
    if (screenfull.isEnabled && screenfull.isFullscreen) {
      screenfull.exit();
    }

    videoPlayerEl.pause();
    videoPlayerShowboxEl.classList.add('hidden');
    videoPlayerEl.classList.add('hidden');
    return;
  }

  isStopping = true;

  return Velocity.animate(titleWrapperEl, {
    opacity: 1,
    duration: 1000,
    begin: function() {
      // stop the on-demand video
      videoPlayerEl.pause();
      // remove the isolation cover
      videoDismissTrigger.classList.add('hidden');
      videoIsolationCoverEl.classList.remove('is-visible');
      videoPlayerWrapperEl.classList.remove('home-hero__video-wrapper--above-isolation-cover');
      videoPlayerOverlayEl.classList.remove('hidden');
      videoPlayerEl.classList.add('fade-out');
      // change the global header back
      headerEl.removeAttribute('data-lock');
      headerEl.classList.remove('kg-header--fill-alt');

      setTimeout(() => {
        // expand the content below the hero
        slideImageContainerEls.forEach(el => el.classList.remove('slide__image-container--shrunk'));
        bgVideoPlayerEl.classList.remove('hidden');
        videoPlayerEl.classList.add('hidden');
        videoPlayerEl.classList.remove('fade-out');
        videoPlayerShowboxEl.classList.add('hidden');
        videoPlayerOverlayEl.classList.remove('is-disabled');
        isStopping = false;
      }, 1000);
    }
  });
}

export default {
  init() {
    initHeroVideo();

  },
  finalize() {
  },
};
